<!-- src/components/PageBanner.vue  通用页面顶部品牌横幅：AI 生成科技风背景 + 标题/副标题叠层
     用法：<PageBanner image-key="monitor" title="..." subtitle="..." />
     image-key 映射 src/assets/images 下的横幅素材（require 由 webpack 静态解析） -->
<template>
  <div class="page-banner">
    <img :src="bannerSrc" class="page-banner-bg" alt="">
    <div class="page-banner-overlay">
      <h2 class="page-banner-title">{{ title }}</h2>
      <p v-if="subtitle" class="page-banner-sub">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
// 横幅素材注册表：新增页面横幅时在此登记 key → 图片路径
const BANNERS = {
  monitor: require('@/assets/images/monitor-banner.jpg'),   // 作品数据监控
  weight: require('@/assets/images/weight-banner.jpg'),     // 账号权重查询
  recharge: require('@/assets/images/recharge-banner.jpg'), // 充值中心
};

export default {
  name: 'PageBanner',
  props: {
    imageKey: { type: String, required: true },  // BANNERS 注册表键名
    title: { type: String, required: true },      // 横幅主标题
    subtitle: { type: String, default: '' },      // 横幅副标题（可省略）
  },
  computed: {
    bannerSrc() { return BANNERS[this.imageKey]; },  // 从注册表取图片 URL
  },
};
</script>

<style scoped>
/* 品牌横幅容器：圆角 + 青紫双色调投影，与查询页 hero 同族 */
.page-banner {
  position: relative;
  height: 96px;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 12px;
  box-shadow: 0 4px 20px rgba(34, 211, 238, 0.12), 0 4px 20px rgba(139, 92, 246, 0.12);
}
/* 背景图：cover 裁剪填满 */
.page-banner-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}
/* 左侧暗渐变叠层：保证白字在任意素材上可读 */
.page-banner-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 26px;
  background: linear-gradient(90deg, rgba(10, 12, 24, 0.6) 0%, rgba(10, 12, 24, 0.28) 48%, rgba(10, 12, 24, 0) 80%);
}
.page-banner-title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 1px;
  color: #f1f5f9;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.45);
}
.page-banner-sub {
  margin: 5px 0 0;
  font-size: 12px;
  letter-spacing: 1.5px;
  color: rgba(226, 232, 240, 0.85);
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);
}
/* 小屏：压低高度与字号 */
@media (max-width: 768px) {
  .page-banner { height: 72px; }
  .page-banner-overlay { padding: 0 16px; }
  .page-banner-title { font-size: 16px; }
  .page-banner-sub { font-size: 11px; letter-spacing: 1px; }
}
</style>
